import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faBaby, 
    faHandHoldingHeart, 
    faUsers, 
    faWater,
    faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import './StaticSection1.css';
import CTAPrimaryButton from '../../Components/CTAButton/CTAPrimaryButton/CTAPrimaryButton';
import { useNavigate } from 'react-router-dom'; 
const Counter = ({ end, suffix, title, icon }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const duration = 2000;
        const increment = end / (duration / 16);
        
        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [end]);

    return (
        <div className="counter-item">
            <div className="counter-icon">
                <FontAwesomeIcon icon={icon} />
            </div>
            <div className="counter-content">
                <div className="counter-number">
                    {count.toLocaleString()}
                    {suffix && <span className="counter-suffix">{suffix}</span>}
                </div>
                <h3 className="counter-title">{title}</h3>
            </div>
        </div>
    );
};

const StaticSection1 = () => {
    const navigate = useNavigate();
    return (
        <section className="static-section">
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} className="counters-column">
                        <div className="counters-wrapper">
                            <Counter 
                                end={292} 
                                suffix="Infants" 
                                title="Milk Provision for Infants"
                                icon={faBaby}
                            />
                            <div className="divider"></div>
                            
                            <Counter 
                                end={76} 
                                title="Sponsorship for Orphans of Gaza Martyrs"
                                icon={faHandHoldingHeart}
                            />
                            <div className="divider"></div>
                            
                            <Counter 
                                end={184} 
                                suffix="Members" 
                                title="Active Members"
                                icon={faUsers}
                            />
                            <div className="divider"></div>
                            
                            <Counter 
                                end={62500} 
                                suffix="Liters" 
                                title="Providing Clean Water to Gaza's North"
                                icon={faWater}
                            />
                        </div>
                    </Col>
                    
                    <Col lg={6} className="content-column">
                        <div className="content-wrapper">
                            <h2 className="section-title">
                                Sanad; <br />a story of hope.
                            </h2>
                            
                            <div className="section-content">
                                <p>
                                    <strong className="highlight">Sanad</strong>, in many languages means support, 
                                    assistance, and reliance on someone who is truly helpful and supportive in 
                                    difficult times and times of need.
                                </p>
                                <p>
                                    And In a world full of wars, conflicts, and crises, many are suffering in 
                                    the shadows and silence, without shelter, food, or care.
                                </p>
                                <p>
                                    But with every suffering, there is hope, humanity, and SANAD.
                                </p>
                                <p>
                                    So SANAD was founded to gather SANADs together and help those whose lives 
                                    have been destroyed by war by providing shelter, healthcare, food, education 
                                    for children, and support for all essential needs that ensure a dignified life.
                                </p>
                                <p>
                                    We work hand in hand with people to provide aid swiftly and efficiently. 
                                    And we need you to help us expand our reach.
                                </p>
                            </div>
                            
                            <CTAPrimaryButton 
                                variant="primary" 
                                className="info-button"
                                onClick={() => navigate('/about')}
                                text="Organization Info"
                                icon={faArrowRight}
                                
                            >
                                Organization Info
                                <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                            </CTAPrimaryButton>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default StaticSection1;
